/**
 * CROSS-SELL COMPONENT - COMPLETE EXTERNAL VERSION
 * Preserves ALL original currency formatting with multi-currency support
 */

(function() {
  'use strict';
  var cachedCartItemCount = null;

  window.__crosssellAbRefreshCartCount = function refreshCachedCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function(res) {
        return res.json();
      })
      .then(function(cart) {
        cachedCartItemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        return cachedCartItemCount;
      })
      .catch(function() {
        if (typeof CartJS !== 'undefined' && CartJS.cart && typeof CartJS.cart.item_count === 'number') {
          cachedCartItemCount = CartJS.cart.item_count;
        }
        return cachedCartItemCount;
      });
  };

  window.__crosssellAbGetCachedCartCount = function getCachedCartCount() {
    if (typeof CartJS !== 'undefined' && CartJS.cart && typeof CartJS.cart.item_count === 'number') {
      return CartJS.cart.item_count;
    }
    if (typeof cachedCartItemCount === 'number') {
      return cachedCartItemCount;
    }
    return null;
  };
})();

(function() {
  'use strict';
  
  // Get section data from inline script
  function getSectionData(sectionElement) {
    var sectionId = sectionElement.getAttribute('data-section-id');
    if (!sectionId) return null;
    
    if (window.crosssellData && window.crosssellData[sectionId]) {
      return window.crosssellData[sectionId];
    }
    
    return {
      sectionId: sectionId,
      productId: parseInt(sectionElement.getAttribute('data-product-id') || '0'),
      basePrice: parseInt(sectionElement.getAttribute('data-base-price') || '0'),
      shopCurrency: sectionElement.getAttribute('data-shop-currency') || 'USD'
    };
  }
  
  function initAll() {
    var crosssellContainers = document.querySelectorAll('[data-crosssell-section-pdp][data-crosssell-ab]');
    crosssellContainers.forEach(function(container) {
      if (container.hasAttribute('data-initialized')) return;
      var data = getSectionData(container);
      if (!data) return;
      container.setAttribute('data-initialized', 'true');
      initCrosssell(container, data);
    });
  }
  
  function initCrosssell(container, data) {
    var SECTION_ID = data.sectionId;
    var CURRENT_PRODUCT_ID = data.productId;
    var baseProductPriceCents = data.basePrice;
    var SHOP_CURRENCY = data.shopCurrency;
    var lastKnownATCPriceCents = baseProductPriceCents;
    var crosssellTotalCents = 0;
    var isOurUpdate = false;
    var checkboxMode = true;
    
    // ============================================================
    // COMPLETE CURRENCY SYMBOL MAPPING - MATCHES ORIGINAL
    // ============================================================
    
    var currencySymbols = {
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'JPY': '¥',
      'CAD': 'C$',
      'AUD': 'A$',
      'CHF': 'CHF',
      'HUF': 'Ft',
      'PLN': 'zł',
      'CZK': 'Kč',
      'SEK': 'kr',
      'NOK': 'kr',
      'DKK': 'kr',
      'INR': '₹',
      'BRL': 'R$',
      'MXN': '$',
      'SGD': 'S$',
      'HKD': 'HK$',
      'NZD': 'NZ$',
      'ZAR': 'R',
      'RUB': '₽',
      'TRY': '₺',
      'UAH': '₴',
      'ILS': '₪',
      'THB': '฿',
      'KRW': '₩',
      'VND': '₫',
      'PHP': '₱',
      'IDR': 'Rp',
      'MYR': 'RM',
      'BGN': 'лв',
      'HRK': 'kn',
      'RON': 'lei'
    };
    
    // ============================================================
    // COMPLETE NUMBER FORMAT DETECTION - MATCHES ORIGINAL
    // ============================================================
    
    /**
     * Detect number format from a price string
     * Returns: 'us' (1,234.56), 'eu' (1.234,56), 'in' (1,23,456.78), 'none'
     */
    function detectNumberFormat(priceString) {
      if (!priceString) return 'us';
      
      var cleanPrice = String(priceString).trim();
      var commaCount = (cleanPrice.match(/,/g) || []).length;
      var dotCount = (cleanPrice.match(/\./g) || []).length;
      
      // No separators
      if (commaCount === 0 && dotCount === 0) {
        return 'none';
      }
      
      // Only one separator
      if (commaCount === 1 && dotCount === 0) {
        var lastCommaIdx = cleanPrice.lastIndexOf(',');
        var afterComma = cleanPrice.substring(lastCommaIdx + 1);
        return (afterComma.length === 3 || afterComma.length === 4) ? 'us' : 'eu';
      }
      
      if (commaCount === 0 && dotCount === 1) {
        return 'us';
      }
      
      // Multiple separators
      var lastCommaIdx = cleanPrice.lastIndexOf(',');
      var lastDotIdx = cleanPrice.lastIndexOf('.');
      
      if (lastDotIdx > lastCommaIdx) {
        return 'us';
      } else if (lastCommaIdx > lastDotIdx) {
        return 'eu';
      }
      
      if (commaCount > 1) {
        return 'in';
      }
      
      return 'us';
    }
    
    /**
     * Parse currency string to cents - EXACT MATCH TO ORIGINAL
     */
    function parseMoney(priceString) {
      if (!priceString) return 0;
      
      var cleaned = String(priceString).trim();
      
      // Remove all known currency symbols
      var symbols = ['$', '€', '£', '¥', 'kr', 'Ft', '₹', '₽', 'C$', 'A$', 'NZ$', 'S$', 'HK$', '₩', '฿', '₡', 'R$', 'zł', 'kč', '₺', '₴', '₪', '₫', '₱', 'Rp', 'RM', 'лв', 'kn', 'lei', 'CHF'];
      symbols.forEach(function(sym) {
        cleaned = cleaned.split(sym).join('');
      });
      
      // Remove 3-letter currency codes
      cleaned = cleaned.replace(/[A-Z]{3}/g, '');
      
      // Remove extra spaces
      cleaned = cleaned.trim().split(' ').join('');
      
      if (!cleaned || cleaned.match(/^[^\d]*$/)) {
        return 0;
      }

      // Dot as thousands only (e.g. 27.000 Ft) — not a US decimal
      var digitDotOnly = cleaned.replace(/[^\d.]/g, '');
      if (digitDotOnly.indexOf(',') === -1 && /^\d{1,3}(\.\d{3})+$/.test(digitDotOnly)) {
        var mergedT = digitDotOnly.replace(/\./g, '');
        var nT = parseInt(mergedT, 10);
        if (!isNaN(nT)) {
          return nT * 100;
        }
      }
      
      var format = detectNumberFormat(cleaned);
      var normalized;
      
      if (format === 'eu') {
        // European: 1.234,56 → remove dots, replace comma with dot
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      } else if (format === 'in') {
        // Indian: 1,23,456.78 → remove all commas
        normalized = cleaned.replace(/,/g, '');
      } else if (format === 'none') {
        normalized = cleaned;
      } else {
        // US: 1,234.56 → remove commas
        normalized = cleaned.replace(/,/g, '');
      }
      
      var parsed = parseFloat(normalized);
      if (isNaN(parsed)) return 0;
      
      return Math.round(parsed * 100);
    }
    
    /**
     * Extract currency symbol from page - MATCHES ORIGINAL
     */
    function detectFormatFromPagePrice() {
      var priceElements = document.querySelectorAll('[data-product-price], #ProductPrice-' + SECTION_ID + ', .product-price .money, .money, [data-price], .atc-total-price');
      
      for (var i = 0; i < priceElements.length; i++) {
        var priceText = priceElements[i].textContent.trim();
        if (priceText && priceText.length > 2) {
          return {
            example: priceText,
            element: priceElements[i]
          };
        }
      }
      return null;
    }
    
    /**
     * Extract currency symbol from price string
     */
    function extractCurrencySymbol(priceString) {
      if (!priceString) return '';
      
      var symbols = ['$', '€', '£', '¥', 'kr', 'Ft', '₹', '₽', 'C$', 'A$', 'NZ$', 'S$', 'HK$', '₩', '฿', '₡', 'R$', 'zł', 'kč', '₺', '₴', '₪', '₫', '₱', 'Rp', 'RM', 'лв', 'kn', 'lei', 'CHF'];
      
      for (var i = 0; i < symbols.length; i++) {
        if (priceString.indexOf(symbols[i]) !== -1) {
          return symbols[i];
        }
      }
      
      var match = priceString.match(/[A-Z]{3}/);
      return match ? match[0] : '';
    }
    
    /**
     * Format cents to localized currency string - EXACT MATCH TO ORIGINAL
     */
    function formatMoney(cents) {
      if (!cents || cents === 0) return '0.00';
      
      var dollars = cents / 100;
      var pagePrice = detectFormatFromPagePrice();
      
      if (!pagePrice) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          try {
            return Shopify.formatMoney(cents, '{{ shop.money_format }}');
          } catch(e) {
            return getCurrencySymbol() + dollars.toFixed(2);
          }
        }
        return getCurrencySymbol() + dollars.toFixed(2);
      }
      
      var examplePrice = pagePrice.example;
      var detectedFormat = detectNumberFormat(examplePrice);
      var currencySymbol = extractCurrencySymbol(examplePrice);
      
      if (!currencySymbol) {
        currencySymbol = getCurrencySymbol();
      }
      
      var formattedNumber;
      
      if (detectedFormat === 'eu') {
        // European format: 1.234,56
        formattedNumber = dollars.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } else if (detectedFormat === 'in') {
        // Indian format: 1,23,456.78
        formattedNumber = dollars.toLocaleString('en-IN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } else {
        // US/Default format: 1,234.56
        formattedNumber = dollars.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      
      // Determine symbol position
      var symbolPos = examplePrice.indexOf(currencySymbol);
      var firstDigitPos = examplePrice.search(/[\d,.\s]/);
      var symbolBefore = symbolPos < firstDigitPos;
      
      if (symbolBefore) {
        return currencySymbol + formattedNumber;
      } else {
        return formattedNumber + ' ' + currencySymbol;
      }
    }
    
    function getCurrencySymbol() {
      return currencySymbols[SHOP_CURRENCY] || SHOP_CURRENCY;
    }
    
    // ============================================================
    // CROSS-SELL CALCULATIONS - MATCHES ORIGINAL
    // ============================================================
    
    function getCrosssellTotal() {
      var total = 0;
      var mainPriceCents = parseMoney(document.querySelector('#ProductPrice-' + SECTION_ID)?.textContent || '0');
      var baseRatio = mainPriceCents > 0 ? mainPriceCents / baseProductPriceCents : 1;

      container.querySelectorAll('[data-crosssell-item]').forEach(function(item) {
        var qty;
        if (checkboxMode) {
          if (!item.classList.contains('is-selected')) return;
          qty = 1;
        } else {
          var qtyInput = item.querySelector('[data-quantity-input]');
          qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
          if (qty <= 0) return;
        }
        var priceEl = item.querySelector('[data-item-price]');
        var priceInBaseCents = parseInt(priceEl && priceEl.getAttribute('data-item-price'), 10) || 0;
        total += Math.round(priceInBaseCents * baseRatio) * qty;
      });

      crosssellTotalCents = total;
      return total;
    }

    function getCrosssellQty() {
      if (checkboxMode) {
        return container.querySelectorAll('[data-crosssell-item].is-selected').length;
      }
      var totalQty = 0;
      container.querySelectorAll('[data-crosssell-item]').forEach(function(item) {
        var qtyInput = item.querySelector('[data-quantity-input]');
        totalQty += parseInt(qtyInput && qtyInput.value, 10) || 0;
      });
      return totalQty;
    }

    /**
     * Main PDP quantity (not the first .product-form__input — that is often the variant select).
     */
    function getMainProductQty() {
      var input =
        document.querySelector('form.productForm input.qty[name="quantity"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="quantity"].qty') ||
        document.querySelector('.product-action input#quantity') ||
        document.querySelector('.qtyField input[name="quantity"]') ||
        document.querySelector('input#quantity[name="quantity"]');
      var n = parseInt(input && input.value, 10);
      return n > 0 ? n : 1;
    }

    /**
     * Main line in cents: unit from #ProductPrice × qty + optional GPO (one-time), always current.
     */
    function getMainLineCents() {
      var priceEl = document.querySelector('#ProductPrice-' + SECTION_ID);
      var unitCents = parseMoney(priceEl ? priceEl.textContent : '0');
      if (unitCents <= 0) {
        unitCents = baseProductPriceCents;
      }
      var line = Math.round(unitCents * getMainProductQty());
      var gpoMoney =
        document.querySelector('.gpo-total .gpo-total-text .money') ||
        document.querySelector('.gpo-app .gpo-total-text .money') ||
        document.querySelector('.gpo-total-text .money') ||
        document.querySelector('.gpo-total-text span');
      if (gpoMoney) {
        var addCents = parseMoney(gpoMoney.textContent);
        if (addCents > 0) {
          line += addCents;
        }
      }
      return line;
    }
    
    function captureATCPrice() {
      var fromMain = getMainLineCents();
      if (fromMain > 0) {
        lastKnownATCPriceCents = fromMain;
        return;
      }
      var atcPrice =
        document.querySelector('#AddToCart-' + SECTION_ID + ' .atc-total-price') ||
        document.querySelector('.custom-total-price .atc-total-price') ||
        document.querySelector('.atc-total-price');
      if (atcPrice) {
        var currentPrice = parseMoney(atcPrice.textContent);
        if (currentPrice > 0) {
          lastKnownATCPriceCents = currentPrice;
        }
      }
    }
    
    // ============================================================
    // PRICE DISPLAY UPDATE
    // ============================================================
    
    function getMainAtcButtons() {
      var form =
        container.closest('form[action*="/cart/add"], form.productForm') ||
        document.querySelector('.product-template--pdp form.productForm, form.productForm[action*="/cart/add"]');
      if (form) {
        var inForm = [].slice.call(
          form.querySelectorAll('button[name="add"].product-form__cart-submit')
        );
        if (inForm.length) {
          return inForm;
        }
      }
      var one = document.querySelector('#AddToCart-' + SECTION_ID);
      return one ? [one] : [];
    }
    
    function setCrosssellTotalOnAtcButton(atcButton, formattedPrice) {
      var buttonTextSpan = atcButton.querySelector('.product-atc-text') || atcButton.querySelector('#AddToCartText-' + SECTION_ID);
      var originalPriceSpan = atcButton.querySelector('.atc-total-price');
      if (originalPriceSpan) {
        originalPriceSpan.style.display = 'none';
      }
      var customPriceDisplay = atcButton.querySelector('.crosssell-total-price');
      if (!customPriceDisplay) {
        customPriceDisplay = document.createElement('span');
        customPriceDisplay.className = 'crosssell-total-price';
        if (buttonTextSpan) {
          buttonTextSpan.appendChild(customPriceDisplay);
        } else {
          atcButton.appendChild(customPriceDisplay);
        }
      }
      customPriceDisplay.style.display = 'inline';
      customPriceDisplay.textContent = '';
      var separator = document.createElement('span');
      separator.textContent = ' · ';
      separator.className = 'crosssell-separator';
      var priceSpan = document.createElement('span');
      priceSpan.textContent = formattedPrice;
      priceSpan.className = 'crosssell-price-amount';
      customPriceDisplay.appendChild(separator);
      customPriceDisplay.appendChild(priceSpan);
    }
    
    function clearCrosssellOnAtcButton(atcButton) {
      var originalPriceSpan = atcButton && atcButton.querySelector('.atc-total-price');
      if (originalPriceSpan) {
        originalPriceSpan.style.display = '';
      }
      var customPriceDisplay = atcButton && atcButton.querySelector('.crosssell-total-price');
      if (customPriceDisplay) {
        customPriceDisplay.style.display = 'none';
      }
    }
    
    function updateTotalPrice() {
      isOurUpdate = true;
      
      var currentCrosssellTotal = getCrosssellTotal();
      var crosssellQty = getCrosssellQty();
      var atcButtons = getMainAtcButtons();
      var atcButtonSticky = document.querySelector('#AddToCart-' + SECTION_ID + '-ab');
      var mainQtyEl =
        document.querySelector('form.productForm input.qty[name="quantity"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="quantity"].qty') ||
        document.querySelector('input#quantity[name="quantity"]');
      var stickyQtyEl = document.querySelector(
        '.stickyCart--pdp[data-section-id="' + SECTION_ID + '"] input.qty[name="quantity"]'
      );
      if (mainQtyEl && stickyQtyEl && mainQtyEl.value !== stickyQtyEl.value) {
        stickyQtyEl.value = mainQtyEl.value;
      }
      
      if (!atcButtons.length) {
        isOurUpdate = false;
        return;
      }
      
      var buttonTextSpanSticky = atcButtonSticky && atcButtonSticky.querySelector('.product-atc-text, #AddToCartText-' + SECTION_ID + '-ab');
      var originalPriceSpanSticky = atcButtonSticky && atcButtonSticky.querySelector('.atc-total-price');
      var customPriceDisplaySticky = atcButtonSticky && atcButtonSticky.querySelector('.crosssell-total-price');
      
      if (crosssellQty > 0) {
        var mainLineCents = getMainLineCents();
        lastKnownATCPriceCents = mainLineCents;
        var grandTotal = mainLineCents + currentCrosssellTotal;
        var formattedPrice = formatMoney(grandTotal);
        
        atcButtons.forEach(function (btn) {
          setCrosssellTotalOnAtcButton(btn, formattedPrice);
        });
        if (originalPriceSpanSticky) {
          originalPriceSpanSticky.style.display = 'none';
        }
        if (atcButtonSticky) {
          if (!customPriceDisplaySticky) {
            customPriceDisplaySticky = document.createElement('span');
            customPriceDisplaySticky.className = 'crosssell-total-price';
            if (buttonTextSpanSticky) {
              buttonTextSpanSticky.appendChild(customPriceDisplaySticky);
            } else {
              atcButtonSticky.appendChild(customPriceDisplaySticky);
            }
          }
          customPriceDisplaySticky.style.display = 'inline';
          customPriceDisplaySticky.textContent = '';
          var sep2 = document.createElement('span');
          sep2.textContent = ' · ';
          sep2.className = 'crosssell-separator';
          var priceSpan2 = document.createElement('span');
          priceSpan2.textContent = formattedPrice;
          priceSpan2.className = 'crosssell-price-amount';
          customPriceDisplaySticky.appendChild(sep2);
          customPriceDisplaySticky.appendChild(priceSpan2);
        }
        
      } else {
        atcButtons.forEach(function (btn) {
          clearCrosssellOnAtcButton(btn);
        });
        if (originalPriceSpanSticky) {
          originalPriceSpanSticky.style.display = '';
        }
        if (customPriceDisplaySticky) {
          customPriceDisplaySticky.style.display = 'none';
        }
        if (typeof window.updatePrice === 'function') {
          window.updatePrice();
        }
      }
      
      setTimeout(function() {
        isOurUpdate = false;
      }, 100);
    }
    
    // ============================================================
    // CART OPERATIONS
    // ============================================================
    
    function updateCartCount() {
      fetch('/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var selectors = ['.cart-count', '.cart-item-count', '[data-cart-count]', '.cartCount', '.cart-count-bubble', '.site-header__cart-count', '.header__cart-count', '.cart-link__count', '.js-cart-count', '.cart__count', '#CartCount', '.cart-icon__count', '.header-cart-count', '.mini-cart__count', '.cart-quantity', '.header__icon-wrapper .count', '[data-cart-item-count]'];
          
          selectors.forEach(function(selector) {
            document.querySelectorAll(selector).forEach(function(el) {
              el.textContent = cart.item_count;
              el.classList.remove('hide', 'hidden', 'is-hidden');
              if (cart.item_count > 0) el.style.display = '';
            });
          });
          
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function(err) { console.error('Cart count update failed:', err); });
    }
    
    // ============================================================
    // EVENT HANDLERS
    // ============================================================
    
    function findAddButtonForItem(item) {
      var variantId = item.getAttribute('data-variant-id');
      if (variantId) {
        return container.querySelector('.crosssell-item__action [data-add-to-cart][data-variant-id="' + variantId + '"]');
      }
      var nextSibling = item.nextElementSibling;
      if (nextSibling && nextSibling.classList.contains('crosssell-item__action')) {
        return nextSibling.querySelector('[data-add-to-cart]');
      }
      return null;
    }
    
    function findCrosssellItemForButton(addBtn) {
      var variantId = addBtn.getAttribute('data-variant-id');
      if (variantId) {
        return container.querySelector('[data-crosssell-item][data-variant-id="' + variantId + '"]');
      }
      var actionWrapper = addBtn.closest('.crosssell-item__action');
      if (actionWrapper) {
        var prevSibling = actionWrapper.previousElementSibling;
        if (prevSibling && prevSibling.hasAttribute('data-crosssell-item')) {
          return prevSibling;
        }
      }
      return null;
    }
    
    function updateAddButtonState(item) {
      if (checkboxMode) return;
      var input = item.querySelector('[data-quantity-input]');
      if (!input) return;
      var addBtn = findAddButtonForItem(item);
      if (addBtn) {
        if (parseInt(input.value, 10) === 0) {
          addBtn.classList.add('is-disabled');
        } else {
          addBtn.classList.remove('is-disabled');
        }
      }
    }
    
    // ============================================================
    // INITIALIZATION
    // ============================================================
    
    // Hide self-referencing cross-sell items
    container.querySelectorAll('[data-crosssell-item]').forEach(function(item) {
      var itemProductId = item.getAttribute('data-product-id');
      if (itemProductId && parseInt(itemProductId, 10) === CURRENT_PRODUCT_ID) {
        if (item.parentElement) item.parentElement.removeChild(item);
      }
    });
    
    var visibleItems = container.querySelectorAll('[data-crosssell-item]');
    if (visibleItems.length === 0) {
      container.style.display = 'none';
      return;
    }
    
    if (checkboxMode) {
      container.addEventListener('click', function(e) {
        var selectBtn = e.target.closest('.crosssell-item__select');
        if (!selectBtn || !container.contains(selectBtn)) return;
        e.preventDefault();
        var item = selectBtn.closest('[data-crosssell-item]');
        if (!item) return;
        item.classList.toggle('is-selected');
        var on = item.classList.contains('is-selected');
        selectBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && typeof window.__crosssellAbRefreshCartCount === 'function') {
          window.__crosssellAbRefreshCartCount();
        }
        updateTotalPrice();
      });
    } else {
      container.addEventListener('click', function(e) {
        var qtyBtn = e.target.closest('[data-action]');
        if (qtyBtn && qtyBtn.closest('.quantity-selector')) {
          e.preventDefault();
          e.stopPropagation();

          var selector = qtyBtn.closest('.quantity-selector');
          var input = selector.querySelector('[data-quantity-input]');
          var currentValue = parseInt(input.value, 10) || 0;
          var action = qtyBtn.getAttribute('data-action');

          if (action === 'increase') {
            var max = parseInt(input.max, 10) || 10;
            if (currentValue < max) input.value = currentValue + 1;
          } else if (action === 'decrease') {
            if (currentValue > 0) input.value = currentValue - 1;
          }

          updateTotalPrice();
          updateAddButtonState(input.closest('[data-crosssell-item]'));
          return false;
        }

        var addBtn = e.target.closest('[data-add-to-cart]');
        if (addBtn) {
          e.preventDefault();
          e.stopPropagation();

          var item = findCrosssellItemForButton(addBtn);
          if (!item) return false;

          var quantityInput = item.querySelector('[data-quantity-input]');
          var quantity = parseInt(quantityInput.value, 10) || 0;
          if (quantity === 0) return false;

          var variantId = addBtn.dataset.variantId;
          addBtn.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
          })
            .then(function(response) {
              return response.ok ? response.json() : response.json().then(function(err) {
                throw new Error(err.description || 'Failed to add to cart');
              });
            })
            .then(function() {
              addBtn.classList.add('is-added');
              quantityInput.value = 0;
              updateAddButtonState(item);
              updateTotalPrice();
              updateCartCount();
              setTimeout(function() {
                addBtn.classList.remove('is-added');
                addBtn.disabled = false;
              }, 3000);
            })
            .catch(function(err) {
              console.error('Add to cart error:', err);
              addBtn.disabled = false;
            });

          return false;
        }
      });

      container.querySelectorAll('[data-quantity-input]').forEach(function(input) {
        input.addEventListener('change', function() {
          updateTotalPrice();
          updateAddButtonState(input.closest('[data-crosssell-item]'));
        });
        input.addEventListener('input', updateTotalPrice);
      });

      container.querySelectorAll('[data-crosssell-item]').forEach(function(item) {
        updateAddButtonState(item);
      });
    }
    
    // Main product listeners
    function initMainProductListeners() {
      function refreshMainAndCrosssell() {
        captureATCPrice();
        updateTotalPrice();
      }

      var boundInputs = window.__crosssellAbQtyInputSet || (window.__crosssellAbQtyInputSet = new WeakSet());
      function bindMainQtyField(el) {
        if (!el || boundInputs.has(el)) return;
        boundInputs.add(el);
        el.addEventListener('change', refreshMainAndCrosssell);
        el.addEventListener('input', refreshMainAndCrosssell);
      }

      bindMainQtyField(document.querySelector('#quantity'));
      document
        .querySelectorAll('form.productForm input.qty[name="quantity"], form[action*="/cart/add"] input[name="quantity"].qty')
        .forEach(bindMainQtyField);

      if (!window.__crosssellAbQtyFieldClickInit) {
        window.__crosssellAbQtyFieldClickInit = true;
        document.addEventListener(
          'click',
          function (e) {
            if (!e.target || !e.target.closest) return;
            if (!e.target.closest('.product-template--pdp .qtyField, .product-action .qtyField')) return;
            setTimeout(function () {
              if (typeof window.__crosssellAbOnMainQtyChain === 'function') {
                window.__crosssellAbOnMainQtyChain();
              }
            }, 0);
          },
          true
        );
      }
      (function pushMainQtyChain() {
        var prev = window.__crosssellAbOnMainQtyChain;
        window.__crosssellAbOnMainQtyChain = function () {
          if (typeof prev === 'function') prev();
          refreshMainAndCrosssell();
        };
      })();
      
      document.querySelectorAll('.single-option-selector, .product-form__variants, .swatch input').forEach(function (selector) {
        selector.addEventListener('change', function () {
          setTimeout(function () {
            captureATCPrice();
            updateTotalPrice();
          }, 100);
          setTimeout(function () {
            captureATCPrice();
            updateTotalPrice();
          }, 300);
        });
      });

      var mainPriceEl = document.querySelector('#ProductPrice-' + SECTION_ID);
      if (mainPriceEl) {
        var priceObs = new MutationObserver(function () {
          if (isOurUpdate) return;
          refreshMainAndCrosssell();
        });
        priceObs.observe(mainPriceEl, { characterData: true, childList: true, subtree: true });
      }

      var gpoRow = document.querySelector('.gpo-total-text');
      if (gpoRow) {
        var gpoObs = new MutationObserver(function () {
          if (isOurUpdate) return;
          refreshMainAndCrosssell();
        });
        gpoObs.observe(gpoRow, { childList: true, characterData: true, subtree: true });
      }
      
      var atcPriceEl = document.querySelector('#AddToCart-' + SECTION_ID + ' .atc-total-price') || document.querySelector('.atc-total-price');
      if (atcPriceEl) {
        var atcObserver = new MutationObserver(function () {
          if (isOurUpdate) return;
          if (getCrosssellQty() === 0) {
            captureATCPrice();
          } else {
            refreshMainAndCrosssell();
          }
        });
        atcObserver.observe(atcPriceEl, { characterData: true, childList: true, subtree: true });
      }
    }
    
    captureATCPrice();
    initMainProductListeners();
    updateTotalPrice();
    if (typeof window.__crosssellAbRefreshCartCount === 'function') {
      window.__crosssellAbRefreshCartCount();
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  
  setTimeout(initAll, 500);
  setTimeout(initAll, 1000);
  setTimeout(initAll, 2000);
})();

/**
 * Checkbox cross-sell: main Add to cart adds main line (qty from form) + qty 1 per selected add-on.
 * Runs in capture phase so it runs before theme.js CartJS handler when add-ons are selected.
 */
(function() {
  if (window.__crosssellAbMainAtcBound) return;
  window.__crosssellAbMainAtcBound = true;

  var addingFromCrosssell = false;

  function refreshCachedCartCount() {
    return typeof window.__crosssellAbRefreshCartCount === 'function'
      ? window.__crosssellAbRefreshCartCount()
      : Promise.resolve(null);
  }

  function getCachedCartCount() {
    return typeof window.__crosssellAbGetCachedCartCount === 'function'
      ? window.__crosssellAbGetCachedCartCount()
      : null;
  }

  function buildMainLineItemFromForm(form) {
    if (!form) return null;
    var idEl = form.querySelector('select[name="id"], input[name="id"]');
    var vid = idEl && parseInt(idEl.value, 10);
    if (!vid) return null;
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
    var item = { id: vid, quantity: qty };
    var properties = {};
    form.querySelectorAll('[name*="properties"]').forEach(function(el) {
      var name = el.getAttribute('name');
      if (!name) return;
      var m = name.match(/properties\[(.*?)\]/);
      if (m) properties[m[1]] = el.value;
    });
    if (Object.keys(properties).length) item.properties = properties;
    var sp = form.querySelector('[name="selling_plan"]');
    if (sp && sp.value) item.selling_plan = parseInt(sp.value, 10);
    return item;
  }

  function getCheckboxCrosssellContainer(sectionId) {
    return document.querySelector(
      '[data-crosssell-section-pdp][data-crosssell-ab][data-section-id="' + sectionId + '"]'
    );
  }

  function getGpoCloneButton(form) {
    if (!form) return null;
    return form.querySelector('.gpo-clone-atc-button');
  }

  function isAbGpoForm(form) {
    if (!form || !document.querySelector('.product-template--pdp')) return false;
    return !!getGpoCloneButton(form);
  }

  function delegateAbAtcToGpo(e, form) {
    var clone = getGpoCloneButton(form);
    if (!clone || clone.disabled) return false;
    e.preventDefault();
    e.stopImmediatePropagation();

    if (!gpoFormPassesValidation(form)) {
      handleGpoValidationFailure(form);
      return true;
    }

    clone.click();
    return true;
  }

  function updateCartCountUi(cart) {
    if (!cart) return;
    if (typeof CartJS !== 'undefined' && CartJS.cart) {
      CartJS.cart = cart;
    }
    if (typeof jQuery !== 'undefined') {
      jQuery(document).trigger('cart.requestComplete', [cart]);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    var selectors = [
      '.cart-count',
      '.cart-item-count',
      '[data-cart-count]',
      '.cartCount',
      '.cart-count-bubble',
      '.site-header__cart-count',
      '.header__cart-count',
      '.cart-link__count',
      '.js-cart-count',
      '.cart__count',
      '#CartCount',
      '.cart-icon__count',
      '.header-cart-count',
      '.mini-cart__count',
      '.cart-quantity',
      '.header__icon-wrapper .count',
      '[data-cart-item-count]'
    ];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.textContent = cart.item_count;
        el.classList.remove('hide', 'hidden', 'is-hidden');
        if (cart.item_count > 0) el.style.display = '';
      });
    });
  }

  function handleAbCartAddError(err) {
    console.error(err);
    document.body.classList.remove('loading', 'showOverly');
    if (typeof jQuery !== 'undefined') {
      var msg = err && err.message ? err.message : 'Error';
      jQuery('.error-message').text(msg);
      jQuery('body').addClass('showOverly');
      jQuery('#errorDrawer').fadeIn(500);
    }
  }

  function finishAbCartAddFlow() {
    document.body.classList.remove('loading', 'showOverly');
    if (document.querySelector('.product-template--pdp')) {
      var cartUrl =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url
          ? window.Shopify.routes.cart_url
          : '/cart';
      window.location.assign(cartUrl);
      return Promise.resolve(null);
    }
    var blockCart = document.querySelector('.block-cart');
    if (blockCart) blockCart.classList.add('active');
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(res) {
      return res.json();
    });
  }

  function addItemsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function(res) {
      if (!res.ok) {
        return res.json().then(function(err) {
          throw new Error((err && err.description) || 'Could not add to cart');
        });
      }
      return res.json();
    });
  }

  function findFocusableGpoField(block) {
    if (!block) return null;
    return block.querySelector(
      '.asg-dropdown-button, .asg-selector-btn, select, input, textarea, button.asg-dropdown-btn'
    );
  }

  function isGpoFieldVisible(field) {
    if (!field || field.disabled) return false;

    var gpoElement = field.closest('.gpo-element');
    if (gpoElement) {
      var elStyle = window.getComputedStyle(gpoElement);
      if (elStyle.display === 'none' || elStyle.visibility === 'hidden') return false;
    }

    var rect = field.getBoundingClientRect();
    if (rect.width > 0 || rect.height > 0) return true;

    var customUi =
      (gpoElement && gpoElement.querySelector('.asg-section, .asg-visual-selector, .asg-dropdown-wrapper')) ||
      field.closest('.asg-section');
    if (customUi) {
      var customRect = customUi.getBoundingClientRect();
      return customRect.width > 0 || customRect.height > 0;
    }

    return field.offsetParent !== null;
  }

  function isGpoInputEmpty(field) {
    if (!field) return true;
    if ((field.tagName || '').toLowerCase() === 'select') return !String(field.value || '').trim();
    if (field.type === 'checkbox' || field.type === 'radio') return !field.checked;
    return !String(field.value || '').trim();
  }

  function clearGpoFieldErrors(gpoApp) {
    if (!gpoApp) return;
    gpoApp.querySelectorAll('.gpo-element.has-error, .gpo-element.gpo-error').forEach(function(el) {
      el.classList.remove('has-error', 'gpo-error');
    });
    gpoApp.querySelectorAll('.gpo-input-wrap.error').forEach(function(el) {
      el.classList.remove('error');
    });
    gpoApp.querySelectorAll('[aria-invalid="true"]').forEach(function(el) {
      el.removeAttribute('aria-invalid');
    });
    gpoApp.querySelectorAll('.gpo-helptext[data-asg-validation="injected"]').forEach(function(el) {
      el.remove();
    });
  }

  function ensureGpoFieldError(gpoElement) {
    if (!gpoElement) return;
    gpoElement.classList.add('has-error', 'gpo-error');
    var wrap = gpoElement.querySelector('.gpo-input-wrap');
    if (wrap) wrap.classList.add('error');
    var field = gpoElement.querySelector('.gpo-input, input:not([type="hidden"]), textarea, select');
    if (field) field.setAttribute('aria-invalid', 'true');

    var helptext = gpoElement.querySelector('.gpo-helptext');
    if (!helptext) {
      helptext = document.createElement('span');
      helptext.className = 'gpo-helptext';
      helptext.dataset.asgValidation = 'injected';
      var anchor = wrap || field || gpoElement.querySelector('.gpo-label') || gpoElement;
      anchor.appendChild(helptext);
    }
    helptext.textContent = 'This field is required.';
    helptext.style.display = 'block';
  }

  function handleGpoValidationFailure(form) {
    var gpoApp = form && form.querySelector('.gpo-app');
    var match = findFirstGpoValidationTarget(gpoApp);
    if (match.scrollTarget) {
      var gpoElement = match.scrollTarget.closest('.gpo-element') || match.scrollTarget;
      ensureGpoFieldError(gpoElement);
    }
    scrollToFirstIncompleteGpoField(form);
    return true;
  }

  function gpoFormPassesValidation(form) {
    var gpoApp = form && form.querySelector('.gpo-app');
    if (!gpoApp) return true;
    clearGpoFieldErrors(gpoApp);
    return !findFirstGpoValidationTarget(gpoApp).scrollTarget;
  }

  function findFirstGpoValidationTarget(gpoApp) {
    if (!gpoApp) return { scrollTarget: null, focusTarget: null };

    var scrollTarget = null;
    var focusTarget = null;

    var invalidEl = gpoApp.querySelector('[aria-invalid="true"]');
    if (invalidEl) {
      scrollTarget =
        invalidEl.closest('.asg-section') ||
        invalidEl.closest('.gpo-element') ||
        invalidEl;
      focusTarget = findFocusableGpoField(scrollTarget) || invalidEl;
      return { scrollTarget: scrollTarget, focusTarget: focusTarget };
    }

    var errorEl = gpoApp.querySelector(
      '.gpo-error, .field-error, .gpo-element.has-error, .gpo-element.gpo-error, .gpo-element.error, .gpo-input-wrap.error'
    );
    if (errorEl) {
      scrollTarget =
        errorEl.closest('.asg-section') ||
        errorEl.closest('.gpo-element') ||
        errorEl;
      focusTarget = findFocusableGpoField(scrollTarget) || errorEl;
      return { scrollTarget: scrollTarget, focusTarget: focusTarget };
    }

    var helpTexts = gpoApp.querySelectorAll('.gpo-helptext, .validation-message, .gpo-validation-message');
    for (var h = 0; h < helpTexts.length; h++) {
      var ht = helpTexts[h];
      var text = (ht.textContent || '').trim();
      if (!text) continue;
      if (ht.offsetParent === null && window.getComputedStyle(ht).display === 'none') continue;
      scrollTarget =
        ht.closest('.asg-section') ||
        ht.closest('.gpo-element') ||
        ht;
      focusTarget = findFocusableGpoField(scrollTarget);
      return { scrollTarget: scrollTarget, focusTarget: focusTarget };
    }

    var selects = gpoApp.querySelectorAll('select[data-type="select"]');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      if (sel.disabled || !isGpoFieldVisible(sel)) continue;
      if (!isGpoInputEmpty(sel)) continue;
      var gpoElement = sel.closest('.gpo-element');
      scrollTarget =
        (gpoElement && gpoElement.querySelector('.asg-section')) ||
        gpoElement ||
        sel.closest('.asg-section') ||
        sel;
      focusTarget = findFocusableGpoField(scrollTarget) || sel;
      return { scrollTarget: scrollTarget, focusTarget: focusTarget };
    }

    var inputs = gpoApp.querySelectorAll(
      '.gpo-input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), ' +
        '.gpo-input-wrap input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), ' +
        '.gpo-input-wrap textarea, textarea.gpo-input'
    );
    for (var j = 0; j < inputs.length; j++) {
      var input = inputs[j];
      if (input.disabled || !isGpoFieldVisible(input)) continue;
      if (!isGpoInputEmpty(input)) continue;
      scrollTarget =
        input.closest('.asg-section') ||
        input.closest('.gpo-element') ||
        input;
      focusTarget = input;
      return { scrollTarget: scrollTarget, focusTarget: focusTarget };
    }

    return { scrollTarget: null, focusTarget: null };
  }

  function scrollGpoFieldIntoView(scrollTarget) {
    if (!scrollTarget) return;
    var headerOffset = 104;
    var rect = scrollTarget.getBoundingClientRect();
    var absoluteTop = window.pageYOffset + rect.top;
    var targetScroll = absoluteTop - headerOffset;

    window.scrollTo({
      top: Math.max(0, targetScroll),
      behavior: 'smooth'
    });
  }

  function scrollToFirstIncompleteGpoField(form) {
    var gpoApp = form && form.querySelector('.gpo-app');
    var match = findFirstGpoValidationTarget(gpoApp);
    var scrollTarget = match.scrollTarget;
    var focusTarget = match.focusTarget;

    if (!scrollTarget) {
      scrollTarget = document.querySelector('.gpo-container') || gpoApp;
    }
    if (!scrollTarget) return;

    scrollGpoFieldIntoView(scrollTarget);
    if (focusTarget && typeof focusTarget.focus === 'function') {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (_err) {
        focusTarget.focus();
      }
    }
  }

  function scheduleGpoValidationScroll(form) {
    [0, 80, 200, 450].forEach(function(delay) {
      setTimeout(function() {
        scrollToFirstIncompleteGpoField(form);
      }, delay);
    });
  }

  function gpoShowsValidationError(gpoApp) {
    if (!gpoApp) return false;
    if (
      gpoApp.querySelector(
        '.gpo-error, .gpo-element.has-error, .gpo-element.gpo-error, .gpo-input-wrap.error, [aria-invalid="true"]'
      )
    ) {
      return true;
    }
    var helpTexts = gpoApp.querySelectorAll('.gpo-helptext, .validation-message, .gpo-validation-message');
    for (var h = 0; h < helpTexts.length; h++) {
      var ht = helpTexts[h];
      if (!(ht.textContent || '').trim()) continue;
      if (ht.offsetParent !== null || window.getComputedStyle(ht).display !== 'none') {
        return true;
      }
    }
    return false;
  }

  function waitForGpoCartChange(baselineCount, maxWaitMs) {
    return new Promise(function(resolve, reject) {
      var start = Date.now();
      var resolved = false;

      function cleanup() {
        if (typeof jQuery !== 'undefined') {
          jQuery(document).off('cart.requestComplete.abGpoCrosssell', onCartEvent);
        }
      }

      function finishSuccess(cart) {
        if (resolved) return;
        resolved = true;
        cleanup();
        resolve(cart);
      }

      function finishFailure() {
        if (resolved) return;
        resolved = true;
        cleanup();
        reject(new Error('Complete all engraving options before adding to cart.'));
      }

      function checkValidationFailure(cart) {
        if (cart && cart.item_count > baselineCount) {
          finishSuccess(cart);
          return true;
        }
        return false;
      }

      function maybeFailEarly() {
        if (Date.now() - start < 800) return;
        var gpoApp = document.querySelector('.product-template--pdp .gpo-app');
        if (gpoApp && gpoShowsValidationError(gpoApp)) {
          finishFailure();
        }
      }

      function onCartEvent(_evt, cart) {
        if (cart && cart.item_count > baselineCount) {
          finishSuccess(cart);
        }
      }

      function poll() {
        fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function(res) {
            return res.json();
          })
          .then(function(cart) {
            if (checkValidationFailure(cart)) {
              return;
            }
            maybeFailEarly();
            if (Date.now() - start >= maxWaitMs) {
              finishFailure();
              return;
            }
            setTimeout(poll, 250);
          })
          .catch(function() {
            finishFailure();
          });
      }

      if (typeof jQuery !== 'undefined') {
        jQuery(document).on('cart.requestComplete.abGpoCrosssell', onCartEvent);
      }

      poll();
    });
  }

  function runGpoCombinedAdd(form, mainItem, selected) {
    var clone = getGpoCloneButton(form);
    if (!clone) return false;

    if (!gpoFormPassesValidation(form)) {
      handleGpoValidationFailure(form);
      return true;
    }

    var crosssellItems = [];
    selected.forEach(function(el) {
      var vid = parseInt(el.getAttribute('data-variant-id'), 10);
      if (vid && vid !== mainItem.id) {
        crosssellItems.push({ id: vid, quantity: 1 });
      }
    });
    if (!crosssellItems.length) return false;

    addingFromCrosssell = true;

    clone.click();
    scheduleGpoValidationScroll(form);

    var syncBaseline = getCachedCartCount();
    var waitPromise =
      typeof syncBaseline === 'number'
        ? waitForGpoCartChange(syncBaseline, 5000)
        : refreshCachedCartCount().then(function(count) {
            return waitForGpoCartChange(typeof count === 'number' ? count : 0, 5000);
          });

    waitPromise
      .then(function() {
        document.body.classList.add('loading');
        return addItemsToCart(crosssellItems);
      })
      .then(function() {
        return finishAbCartAddFlow();
      })
      .then(function(cart) {
        if (cart) updateCartCountUi(cart);
      })
      .catch(function(err) {
        document.body.classList.remove('loading', 'showOverly');
        scrollToFirstIncompleteGpoField(form);
        var gpoApp = form.querySelector('.gpo-app');
        var gpoHasVisibleError =
          gpoApp &&
          gpoApp.querySelector(
            '.error, .errors, .gpo-error, .field-error, [class*="error"]:not(.hide):not(.hidden)'
          );
        if (!gpoHasVisibleError) {
          handleAbCartAddError(err);
        }
      })
      .finally(function() {
        addingFromCrosssell = false;
      });

    return true;
  }

  function runCombinedAddFromForm(form) {
    if (addingFromCrosssell) return false;
    var sectionEl = form.closest('[id^="ProductSection"]');
    if (!sectionEl) return false;
    var sectionId = sectionEl.getAttribute('data-section-id');
    if (!sectionId) return false;
    var container = getCheckboxCrosssellContainer(sectionId);
    if (!container) return false;
    var selected = container.querySelectorAll('[data-crosssell-item].is-selected');
    if (selected.length === 0) return false;

    var mainItem = buildMainLineItemFromForm(form);
    if (!mainItem) return false;

    if (isAbGpoForm(form)) {
      return runGpoCombinedAdd(form, mainItem, selected);
    }

    var items = [mainItem];
    selected.forEach(function(el) {
      var vid = parseInt(el.getAttribute('data-variant-id'), 10);
      if (vid && vid !== mainItem.id) {
        items.push({ id: vid, quantity: 1 });
      }
    });

    addingFromCrosssell = true;
    document.body.classList.add('loading');

    addItemsToCart(items)
      .then(function() {
        return finishAbCartAddFlow();
      })
      .then(function(cart) {
        if (cart) updateCartCountUi(cart);
      })
      .catch(handleAbCartAddError)
      .finally(function() {
        addingFromCrosssell = false;
      });

    return true;
  }

  document.addEventListener(
    'click',
    function(e) {
      var btn = e.target.closest('.product-form__cart-submit');
      if (!btn || btn.closest('[data-crosssell-section]') || btn.closest('[data-crosssell-section-pdp]')) return;
      if (btn.classList.contains('gpo-clone-atc-button')) return;
      if (btn.getAttribute('disabled') === 'disabled' || btn.disabled) return;
      var idMatch = btn.id && btn.id.match(/^AddToCart-(.+)$/);
      if (!idMatch) return;
      var form = btn.closest('form');
      if (!form || !form.classList.contains('productForm')) return;
      if (runCombinedAddFromForm(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      if (isAbGpoForm(form)) {
        delegateAbAtcToGpo(e, form);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function(e) {
      var form = e.target;
      if (!form.matches || !form.matches('form.productForm')) return;
      if (runCombinedAddFromForm(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      if (isAbGpoForm(form)) {
        delegateAbAtcToGpo(e, form);
      }
    },
    true
  );
})();

// Move AB cross-sell section above product action
(function() {
  function moveCrosssell() {
    var crosssell = document.querySelector('[data-crosssell-section-pdp][data-crosssell-ab]');
    var productAction = document.querySelector('.product-action');
    if (crosssell && productAction && !crosssell.hasAttribute('data-moved')) {
      crosssell.setAttribute('data-moved', 'true');
      productAction.parentNode.insertBefore(crosssell, productAction);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveCrosssell);
  } else {
    moveCrosssell();
  }
})();